var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTftLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 26 26"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#tft-logo_svg__clip0_3135_775)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "tft-logo_svg__a",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 26,
    height: 26
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.8.2H.2v25.6h25.6V.2z",
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#CDDCFE",
    mask: "url(#tft-logo_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.696 12.891c3.558 3.27 3.552 6.669 3.552 6.669-1.328-2.86-2.989-3.552-2.989-3.552 3.718 4.854.128 5.44.128 5.44s-5.645 1.354-12.57-5.06C-.104 9.977 6.638 8.29 6.638 8.29s-6.931.467-3.45 6.636c3.898 6.253 11.613 8.724 11.613 8.724s-4.636-.032-8.496-3.021c0 0 4.932 4.88 12.57 5.161 7.638.282 5.491-6.156 5.491-6.156s-1.77-4.301-5.67-6.746v.003z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.906 5.368l-.032 11.571c2.457 1.76 4.623 2.515 6.252 2.813l.032-14.38h6.675L25.41.2H.59L3.19 5.368h6.717z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "tft-logo_svg__clip0_3135_775"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(.2 .2)",
    d: "M0 0h25.6v25.6H0z"
  })))));
}
export default __webpack_public_path__ + "static/svg/tft-logo.svg";
export { SvgTftLogo as ReactComponent };